import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0D00DataDiv } from '../../../commons/kymw0d/kymw0d00/kymw0d00.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FileUploadService, FileAccept } from './../../../commons/kymw02/file-upload/file-upload.service';
import { RegistPlanGoodsInfoService } from './api-services/regist-plan-goods-info-service';
import { UpdateProductionCenterCommentService } from './api-services/update-production-center-comment-service';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW2900Model } from '../kymw2900/kymw2900.model';

/**
 * 農産ﾌﾛﾝﾄ連携画面を管理するクラス
 *
 * @export KYMW2900Component
 * @class KYMW2900Component
 */
@Component({
  selector: 'app-kymw2900',
  templateUrl: 'kymw2900.component.html',
  styleUrls: ['kymw2900.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW2900Component extends PlessViewHelperSub implements OnInit {

  param: any;
  KYMW2900Model: KYMW2900Model = new KYMW2900Model;
  KYMW0D00InputVO: KYMW0D00InputModel = new KYMW0D00InputModel();

  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;
  
  /**
   * Creates an instance of KYMW2900Component.
   * @param {PlessDialogServiceSub} dialogService ダイアログサービス
   * @param {RegistPlanGoodsInfoService} registPlanGoodsInfoService
   * @param {UpdateProductionCenterCommentService} updateProductionCenterCommentService
   * @param {FileUploadService} fileUploadService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW2900Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private registPlanGoodsInfoService: RegistPlanGoodsInfoService,
    private updateProductionCenterCommentService: UpdateProductionCenterCommentService,
    private fileUploadService: FileUploadService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2900';

    // 権限取得
    if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {    // 「2：フルコントロール」の場合
      //「商品企画情報」を選択状態にする
      this.KYMW2900Model.uploadType = '1';
    } else {
      this.btn_Close.nativeElement.focus();
    }
  }

  /**
   * 商品企画情報を選択した状態で、「取込」ボタンを押下時に呼び出されるメソッド。
   */
  public registPlanGoodsInfo(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
        // 商品企画情報の取込
        this.registPlanGoodsInfoService.execute(selectedFiles[0], (data: any) => {
          const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
          // 画面ＩＤ
          inpVO.dispId = 'KYMW2900';
          // データ区分
          inpVO.dataDiv = KYMW0D00DataDiv.DATA_DIV_KYMW2900_PLAN_GOODS;
          // 正常件数
          inpVO.normalNum = data.NormalNum;
          // 注意件数
          inpVO.attentionNum = data.AttentionNum;
          // 異常件数
          inpVO.abnormalNum = data.AbnormalNum;
          // ＤＢ更新件数
          inpVO.updateNum = data.UpdateNum;
          // 処理件数
          inpVO.manageNum = data.ManageNum;

          const ref = this.dialogService.openModal(KYMW0D00Component);
          const inst = ref.componentInstance as KYMW0D00Component;

          inst.parent = this;
          inst.setInterfaceParam(inpVO);
          inst.closeFunction = () => {
            ref.close();
          };
        });
      }
    }, [FileAccept.CSV]);
  }

  /**
   * 「産地コメント情報」を選択した状態で、「取込」ボタンを押下時に呼び出されるメソッド。
   */
  public updateProductionCenterComment(): void {
    // ファイル選択ダイアログを開く
    // ファイルはmultipleの場合を考慮して配列で保持、１件のみならselectedFiles[0]で使用
    this.fileUploadService.upload((selectedFiles: File[]) => {
      // 拡張子取得(小文字に変換して取得する)
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      // 取得した拡張子が想定されているものかチェック
      if (extension !== 'csv') {
        this.dialogService.openAlertGetMessage('E0220');
      } else {
        // 産地コメント情報の取込
        this.updateProductionCenterCommentService.execute(selectedFiles[0], (data: any) => {
          const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
          // 画面ＩＤ
          inpVO.dispId = 'KYMW2900';
          // データ区分
          inpVO.dataDiv = KYMW0D00DataDiv.DATA_DIV_KYMW2900_COMMENT;
          // 正常件数
          inpVO.normalNum = data.NormalNum;
          // 注意件数
          inpVO.attentionNum = data.AttentionNum;
          // 異常件数
          inpVO.abnormalNum = data.AbnormalNum;
          // ＤＢ更新件数
          inpVO.updateNum = data.UpdateNum;
          // 処理件数
          inpVO.manageNum = data.ManageNum;

          const ref = this.dialogService.openModal(KYMW0D00Component);
          const inst = ref.componentInstance as KYMW0D00Component;

          inst.parent = this;
          inst.setInterfaceParam(inpVO);
          inst.closeFunction = () => {
            ref.close();
          };
        });
      }
    }, [FileAccept.CSV]);
  }

  /**
   * 「取込」ボタン押下時イベント
   */
  public eventUpload_CLICKHandler(): void {
    if (this.KYMW2900Model.uploadType === '1') {
      //商品企画情報」
      this.registPlanGoodsInfo();
    } else if (this.KYMW2900Model.uploadType === '2') {
      //「産地コメント情報」
      this.updateProductionCenterComment();
    }
  }
}
